export default [
  {
    path: '/votes/create',
    name: 'Vote_Create',
    component: () => import('@/views/votes/create.vue'),
    meta: {
      authRequired: true,
      permission: 'votes.store'
    }
  },
  {
    path: '/votes',
    name: 'Vote_Index',
    component: () => import('@/views/votes/list.vue'),
    meta: {
      authRequired: true,
      permission: 'votes.index'
    }
  },
  {
    path: '/votes/:id/edit',
    name: 'Vote_Edit',
    component: () => import('@/views/votes/edit.vue'),
    meta: {
      authRequired: true,
      permission: 'votes.update',
      navActiveLink: 'Vote_Index',
    }
  },
  {
    path: '/my-votes',
    name: 'My_Votes',
    component: () => import('@/views/votes/inbox.vue'),
    meta: {
      authRequired: true,
      permission: 'my-votes.index',
    }
  },
  {
    path: '/my-votes/:id',
    name: 'My_Vote_Detail',
    component: () => import('@/views/votes/show.vue'),
    meta: {
      authRequired: true,
      permission: 'my-votes.show',
      navActiveLink: 'My_Votes',
    }
  },
]
